<template>
  <section class="time-grid">
    <div class="stat">
      <div class="value">{{ formattedCycleTime }}</div>
      <div class="label">Cycle Time</div>
    </div>
    <div class="stat">
      <div class="value">{{ formattedBackgroundTime }}</div>
      <div class="label">Background Time</div>
    </div>
  </section>
</template>

<script>
import { computed } from 'vue';
export default {
  name: 'TimeStats',
  props: {
    cycleTime: { type: Number, default: 0 },
    backgroundTime: { type: Number, default: 0 },
  },
  setup(props) {
    const formatTime = (timeInSec) => {
      if (!timeInSec) return '0:00';
      const totalSeconds = Math.floor(timeInSec);
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;
      const formattedSeconds = seconds.toString().padStart(2, '0');
      return minutes < 10
        ? `${minutes}:${formattedSeconds}`
        : `${minutes.toString().padStart(2, '0')}:${formattedSeconds}`;
    };
    const formattedCycleTime = computed(() => {
      return formatTime(props.cycleTime);
    });

    const formattedBackgroundTime = computed(() => {
      return formatTime(props.backgroundTime);
    });

    return {
      formattedCycleTime,
      formattedBackgroundTime,
    };
  },
};
</script>

<style scoped>
.time-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--gap);
  min-height: 0;
}
.stat {
  border: 1px solid #e5e7eb;
  border-radius: var(--radius);
  background: #fff;
  padding: clamp(8px, 1.5vw, 14px);
  display: grid;
  place-items: center;
  text-align: center;
}
.value {
  font-size: clamp(18px, 2.2vw, 28px);
  font-weight: 600;
  color: #1f2937;
  line-height: 1.1;
}
.label {
  margin-top: 6px;
  font-size: clamp(10px, 0.9vw, 14px);
  color: #4b5563;
}
@media (max-width: 520px) {
  .time-grid {
    grid-template-columns: 1fr;
  }
}
</style>
